export function languageBrowser(): string {
  try {
    return new Intl.Locale(navigator.language).language?.toLowerCase() as string
  } catch (e) {
    const langSplit = window.navigator.language.split('-')
    return langSplit[0].toLowerCase()
  }
}
